/**
 * Shadcn-style theme for Dashboard Summary card (CloudCatcher).
 * Muted backgrounds, rounded corners, subtle borders — consistent with ui.shadcn.com/blocks.
 */
export const summaryCardTheme = {
  colors: {
    background: "#fafafa",
    card: "#ffffff",
    cardMuted: "rgba(255,255,255,0.8)",
    border: "#e4e4e7",
    borderLight: "#f4f4f5",
    text: "#18181b",
    textMuted: "#71717a",
    textMutedLight: "#a1a1aa",
    accent: "#3b82f6",
    accentHover: "#2563eb",
    issue: "#64748b",
    /** USD amounts — matches FinOps (`CostInsight`) */
    dollar: "#228B22",
    success: "#0d9488",
    warning: "#ca8a04",
    severity: {
      CRITICAL: "#94a3b8",
      HIGH: "#64748b",
      MEDIUM: "#ca8a04",
      LOW: "#0ea5e9",
    },
    chart: ["#3b82f6", "#8b5cf6", "#f59e0b", "#64748b"],
  },
  radius: {
    sm: "6px",
    md: "8px",
    lg: "12px",
    xl: "16px",
  },
  shadow:
    "0 1px 3px 0 rgba(0,0,0,0.05), 0 1px 2px -1px rgba(0,0,0,0.05)",
  chartTooltip: {
    backgroundColor: "#ffffff",
    border: "1px solid #e4e4e7",
    borderRadius: "8px",
    padding: "8px 12px",
    fontSize: "12px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)",
  },
};
